var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGeckoboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4298_4008)"
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_4298_4008)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.2807 0H27.7193C34.5018 0 40 5.49824 40 12.2807V27.7193C40 34.5018 34.5018 40 27.7193 40H12.2807C5.49824 40 0 34.5018 0 27.7193V12.2807C0 5.49824 5.49824 0 12.2807 0Z",
  fill: "#16113A"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_4298_4008",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 40,
  height: 40
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.2807 0H27.7193C34.5018 0 40 5.49824 40 12.2807V27.7193C40 34.5018 34.5018 40 27.7193 40H12.2807C5.49824 40 0 34.5018 0 27.7193V12.2807C0 5.49824 5.49824 0 12.2807 0Z",
  fill: "white"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4298_4008)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.0516 9.50957L29.8 10.6625V18.1248H31.2045V28.8362C31.2045 30.1358 30.1354 31.2048 28.8358 31.2048H11.1643C9.86466 31.2048 8.79553 30.1358 8.79553 28.8362V11.1656C8.79553 9.86599 9.86466 8.79686 11.1643 8.79686H28.3746C28.9405 8.7759 29.5485 9.06935 30.0516 9.50957Z",
  fill: "#0FD354"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.9257 9.40481C30.6595 9.97075 31.2045 10.8301 31.2045 11.6267V18.4392C30.0306 20.9337 29.1083 22.9041 28.8358 23.5329C27.2635 26.8867 22.3164 30.6389 16.6565 27.9976C10.9337 25.3356 10.6402 19.2567 12.2544 15.7981C14.0153 12.004 17.4741 10.5157 20.849 12.0878C22.4002 12.8006 23.616 14.3307 24.0563 16.0496C24.4965 17.8104 24.0982 19.6131 22.9452 21.1433C22.1277 22.2542 20.5555 22.4639 19.4654 21.6464C18.3754 20.8288 18.1448 19.2567 18.9833 18.1458C19.2977 17.7265 19.2768 17.433 19.2349 17.2654C19.1511 16.93 18.9624 16.7203 18.7527 16.6156C18.3964 16.4269 17.5998 16.0706 16.7823 17.8942C16.6774 18.1039 15.1682 21.7721 18.7946 23.47C21.8972 24.9163 23.9095 22.3171 24.3288 21.4158L29.9257 9.40481Z",
  fill: "#16113A"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_4298_4008",
  x: -30,
  y: -30,
  width: 100,
  height: 100,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0720881 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4298_4008"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_4298_4008",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4298_4008"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
})))));
export { SvgGeckoboard as ReactComponent };
export default __webpack_public_path__ + "static/media/geckoboard.503444aa.svg";